module.exports = __webpack_public_path__ + "img/158.09d87794.jpg";